module.exports = __webpack_public_path__ + "static/media/rotaClockWhite.a7c27a62.svg";